export const benches = [
  { lng: -113.941566851402, lat: 50.92089531812 },
  { lng: -113.980191817422, lat: 50.886711756731 },
  { lng: -113.937517375937, lat: 50.922253074379 },
  { lng: -113.945366677135, lat: 50.919726891396 },
  { lng: -113.93750919236, lat: 50.922292042218 },
  { lng: -113.982283379122, lat: 50.888397630751 },
  { lng: -113.945392579573, lat: 50.919744578608 },
  { lng: -113.94155687291, lat: 50.920882683179 },
  { lng: -114.209194346368, lat: 51.024051887731 },
  { lng: -114.202290202554, lat: 51.022939085648 },
  { lng: -113.991987640677, lat: 50.885419410841 },
  { lng: -113.996177866292, lat: 50.889570868902 },
  { lng: -113.992936934208, lat: 50.886555283132 },
  { lng: -113.996747592387, lat: 50.892081481274 },
  { lng: -114.14817745561, lat: 51.124702818427 },
  { lng: -114.209204778475, lat: 51.024023564741 },
  { lng: -114.018253427283, lat: 50.956355072729 },
  { lng: -114.019570062176, lat: 50.958464354612 },
  { lng: -114.019584193352, lat: 50.958483380195 },
  { lng: -114.064239860849, lat: 50.987660480622 },
  { lng: -114.091916418936, lat: 51.186372066905 },
  { lng: -114.091392965454, lat: 51.04601186108 },
  { lng: -114.138480430952, lat: 51.056568357831 },
  { lng: -114.139015500315, lat: 50.990919595384 },
  { lng: -114.155019091362, lat: 50.985601560272 },
  { lng: -114.103440106921, lat: 51.07258200023 },
  { lng: -114.087084978824, lat: 50.973831444922 },
  { lng: -114.02045316419, lat: 51.005775737888 },
  { lng: -114.226172600762, lat: 51.127549225251 },
  { lng: -113.92808521237, lat: 51.06229939603 },
  { lng: -114.032702805958, lat: 51.049535577637 },
  { lng: -114.109439161787, lat: 51.016286739438 },
  { lng: -114.110860741304, lat: 51.020837716419 },
  { lng: -113.98637915944, lat: 51.045392135421 },
  { lng: -114.185959790315, lat: 51.134426343992 },
  { lng: -114.076527899244, lat: 51.087567224326 },
  { lng: -114.192503585694, lat: 51.105658831535 },
  { lng: -113.928595529256, lat: 51.073787933981 },
  { lng: -114.094515024775, lat: 51.16860486512 },
  { lng: -113.979949498264, lat: 50.929622330604 },
  { lng: -114.04568710755, lat: 51.038836916757 },
  { lng: -114.071278748579, lat: 51.160635737161 },
  { lng: -114.081294800929, lat: 51.023506016788 },
  { lng: -114.069545685952, lat: 51.054007514807 },
  { lng: -113.931894694769, lat: 51.127779842341 },
  { lng: -114.11908970131, lat: 50.989047788076 },
  { lng: -114.09216323335, lat: 51.045918466908 },
  { lng: -114.17878098609, lat: 51.044709639388 },
  { lng: -113.942688244646, lat: 51.107240576223 },
  { lng: -114.010322361367, lat: 51.148140883565 },
  { lng: -114.250325407423, lat: 51.112128253665 },
  { lng: -113.92233187969, lat: 51.073941386729 },
  { lng: -114.046947016647, lat: 51.036931998567 },
  { lng: -114.070186973476, lat: 51.040895350132 },
  { lng: -114.096840327659, lat: 50.998407646415 },
  { lng: -114.088522611483, lat: 51.16420261971 },
  { lng: -114.064670944875, lat: 51.033317852734 },
  { lng: -114.08640340778, lat: 51.074454011458 },
  { lng: -114.124894537188, lat: 51.146676863431 },
  { lng: -114.110951923883, lat: 51.137147662869 },
  { lng: -113.923149980946, lat: 51.110164812127 },
  { lng: -114.117572447744, lat: 50.976983204994 },
  { lng: -114.067051892053, lat: 50.985156646711 },
  { lng: -114.081836541093, lat: 51.186284187663 },
  { lng: -113.986864382248, lat: 50.922473021929 },
  { lng: -114.138496557321, lat: 51.056492533807 },
  { lng: -114.003629296162, lat: 50.987194491834 },
  { lng: -114.124739099746, lat: 51.18009247486 },
  { lng: -114.165155681379, lat: 51.083526996353 },
  { lng: -113.943423520617, lat: 50.895344646556 },
  { lng: -114.062967864379, lat: 51.030213220905 },
  { lng: -114.01000721952, lat: 51.015067172345 },
  { lng: -113.978403464571, lat: 50.866531499872 },
  { lng: -114.020391444613, lat: 51.005057487509 },
  { lng: -114.061041756006, lat: 51.10005333976 },
  { lng: -114.113951088491, lat: 51.021212416774 },
  { lng: -114.222696975474, lat: 51.12327939853 },
  { lng: -114.084222798157, lat: 50.999480403766 },
  { lng: -114.081568672826, lat: 51.076692195168 },
  { lng: -114.067724899024, lat: 51.05955690255 },
  { lng: -114.04347604478, lat: 51.168655561512 },
  { lng: -113.923280923185, lat: 51.111635111136 },
  { lng: -113.979771188482, lat: 50.874248563927 },
  { lng: -114.082524944331, lat: 51.034211479009 },
  { lng: -114.114212138615, lat: 51.021649927903 },
  { lng: -114.082366731096, lat: 51.167418537418 },
  { lng: -114.117871499736, lat: 51.110611900303 },
  { lng: -114.176789964508, lat: 51.022797298794 },
  { lng: -114.009990578481, lat: 50.988241839756 },
  { lng: -114.047579634225, lat: 51.036114465114 },
  { lng: -114.027034817717, lat: 51.057814529557 },
  { lng: -114.116321386689, lat: 51.019171168106 },
  { lng: -114.033274200309, lat: 50.970260600164 },
  { lng: -113.943386249326, lat: 50.894185972897 },
  { lng: -114.073409620206, lat: 51.162019441831 },
  { lng: -113.996820686653, lat: 51.025218984207 },
  { lng: -114.199283310597, lat: 51.10189342423 },
  { lng: -113.939346048791, lat: 51.123735418042 },
  { lng: -114.095988824063, lat: 50.995623345653 },
  { lng: -114.203922474979, lat: 51.013815129488 },
  { lng: -114.029873928192, lat: 50.976542292391 },
  { lng: -114.070153019638, lat: 51.041403842797 },
  { lng: -113.947197750502, lat: 50.902163174688 },
  { lng: -113.952549488649, lat: 51.128535933598 },
  { lng: -114.117496642803, lat: 50.977230194454 },
  { lng: -114.101506776476, lat: 51.104513177885 },
  { lng: -114.015379312179, lat: 50.955943981512 },
  { lng: -114.136544025139, lat: 51.098921783751 },
  { lng: -114.09098140818, lat: 50.88330313584 },
  { lng: -114.070157240577, lat: 51.041378413684 },
  { lng: -114.20831654002, lat: 51.061535966425 },
  { lng: -114.087246332433, lat: 51.074484978788 },
  { lng: -114.195890803183, lat: 51.022868505692 },
  { lng: -114.08826440591, lat: 51.011531530421 },
  { lng: -113.999324442883, lat: 51.047663145072 },
  { lng: -114.128244205034, lat: 51.169434919271 },
  { lng: -114.06716906935, lat: 50.984883996167 },
  { lng: -114.077823445771, lat: 51.165030113791 },
  { lng: -114.091384490506, lat: 51.046035970979 },
  { lng: -113.937162131056, lat: 50.916775969739 },
  { lng: -113.994338961348, lat: 51.026644992941 },
  { lng: -114.019176406597, lat: 51.06472912578 },
  { lng: -114.096534622157, lat: 51.070819700172 },
  { lng: -114.022137036269, lat: 50.885026837428 },
  { lng: -114.121236244952, lat: 50.985389303815 },
  { lng: -114.068390810685, lat: 51.018786165058 },
  { lng: -114.081047655168, lat: 50.918128278414 },
  { lng: -114.091098430897, lat: 51.057988402027 },
  { lng: -114.157626905007, lat: 51.078519706385 },
  { lng: -114.223922798993, lat: 51.14765521057 },
  { lng: -113.952978719057, lat: 50.888753675921 },
  { lng: -114.098306621821, lat: 50.978345208516 },
  { lng: -114.079164965978, lat: 51.103539429616 },
  { lng: -114.076098781946, lat: 51.034278609159 },
  { lng: -114.031254025607, lat: 50.916503386049 },
  { lng: -114.094514817784, lat: 51.168577749226 },
  { lng: -114.089264208745, lat: 51.011904233622 },
  { lng: -113.939344099704, lat: 51.12371407749 },
  { lng: -113.968808072032, lat: 51.11786640289 },
  { lng: -114.057118543966, lat: 51.145728107773 },
  { lng: -113.986870182613, lat: 50.922437164478 },
  { lng: -113.950577352799, lat: 50.915553278921 },
  { lng: -113.979539031623, lat: 50.922760406193 },
  { lng: -114.066621033652, lat: 50.986010618306 },
  { lng: -114.229718600332, lat: 51.158011098479 },
  { lng: -114.140348771513, lat: 50.97731458607 },
  { lng: -113.987477353683, lat: 50.928649317228 },
  { lng: -114.082673905455, lat: 51.076023754816 },
  { lng: -114.188322386161, lat: 51.136777051251 },
  { lng: -113.952257996143, lat: 51.128251405465 },
  { lng: -114.156921370152, lat: 51.104329681042 },
  { lng: -113.965107440745, lat: 51.11547845799 },
  { lng: -113.95281826433, lat: 50.889418227417 },
  { lng: -114.044248420751, lat: 51.163263950726 },
  { lng: -114.101135548985, lat: 51.03239676817 },
  { lng: -114.142737187526, lat: 51.159689900185 },
  { lng: -114.138465494849, lat: 51.056594189506 },
  { lng: -114.217351507025, lat: 51.046683269475 },
  { lng: -114.120673642287, lat: 50.984767800887 },
  { lng: -114.06695535733, lat: 50.985583411367 },
  { lng: -114.081454847962, lat: 51.076780283551 },
  { lng: -114.044326696575, lat: 51.041047124371 },
  { lng: -114.102654529383, lat: 51.15016277265 },
  { lng: -113.951237991101, lat: 50.886227938866 },
  { lng: -114.03028179976, lat: 50.965688500318 },
  { lng: -113.977950607882, lat: 50.865983858003 },
  { lng: -114.083309529523, lat: 51.011147835065 },
  { lng: -114.214953690335, lat: 51.132075284141 },
  { lng: -114.097135419697, lat: 51.026043910385 },
  { lng: -114.082493294075, lat: 51.166014491447 },
  { lng: -114.063836914269, lat: 51.028681952785 },
  { lng: -114.223810866339, lat: 51.147498734468 },
  { lng: -114.138467399216, lat: 51.056520565038 },
  { lng: -114.124810638295, lat: 50.988082601254 },
  { lng: -113.995022338892, lat: 51.030978453131 },
  { lng: -114.069630137662, lat: 51.04111321963 },
  { lng: -113.967572935196, lat: 50.890568737082 },
  { lng: -114.155909775734, lat: 50.99658478791 },
  { lng: -114.156680021365, lat: 51.077315483534 },
  { lng: -114.110690306046, lat: 51.019779403977 },
  { lng: -114.097129691352, lat: 51.026010138802 },
  { lng: -114.124262205948, lat: 51.101002636243 },
  { lng: -114.090319609147, lat: 50.881547645568 },
  { lng: -114.077524287253, lat: 51.053786097538 },
  { lng: -114.088550175409, lat: 50.99557153081 },
  { lng: -114.164681546111, lat: 51.081447719648 },
  { lng: -114.136544341698, lat: 51.099029254701 },
  { lng: -114.020405288858, lat: 51.004996784201 },
  { lng: -114.224303518394, lat: 51.047389488632 },
  { lng: -114.027003695992, lat: 50.974490917133 },
  { lng: -114.081439599707, lat: 51.023975300492 },
  { lng: -114.062415147082, lat: 51.029485238296 },
  { lng: -114.045836547362, lat: 51.038525033725 },
  { lng: -114.099584302447, lat: 50.975741096424 },
  { lng: -114.138492726216, lat: 51.056619342845 },
  { lng: -114.123886121668, lat: 51.175374099844 },
  { lng: -114.008644560284, lat: 51.017162317241 },
  { lng: -114.123899859927, lat: 51.173645532199 },
  { lng: -113.973988409197, lat: 50.88773713718 },
  { lng: -114.192501353207, lat: 51.105704061238 },
  { lng: -114.043487710589, lat: 50.925997253289 },
  { lng: -114.098147964569, lat: 50.978661093807 },
  { lng: -114.189883139003, lat: 51.101573356498 },
  { lng: -114.105584459994, lat: 51.16251178029 },
  { lng: -114.121349343157, lat: 51.06420686648 },
  { lng: -114.008836362396, lat: 51.025691589069 },
  { lng: -113.995298083306, lat: 51.01989026894 },
  { lng: -114.090462130249, lat: 50.998060558861 },
  { lng: -114.120614285865, lat: 50.984870424455 },
  { lng: -114.117474112622, lat: 50.977478624404 },
  { lng: -114.030248798096, lat: 50.977557760845 },
  { lng: -113.91498037725, lat: 51.112375645102 },
  { lng: -113.986322466553, lat: 50.872020886625 },
  { lng: -114.06405284665, lat: 51.02669383898 },
  { lng: -114.206068984253, lat: 51.148860870622 },
  { lng: -114.099863892958, lat: 50.975057045329 },
  { lng: -114.118780487979, lat: 51.138954203852 },
  { lng: -114.010014003791, lat: 51.015043231982 },
  { lng: -113.988857921729, lat: 50.93144038833 },
  { lng: -114.090596006729, lat: 50.880979553605 },
  { lng: -114.062987355234, lat: 51.029478931529 },
  { lng: -114.199292751789, lat: 51.011712742539 },
  { lng: -113.979155433784, lat: 50.940350329162 },
  { lng: -114.087467923321, lat: 50.956802879796 },
  { lng: -113.99487682612, lat: 51.027737103715 },
  { lng: -114.069628649699, lat: 51.041142246589 },
  { lng: -114.077941623825, lat: 51.052672487922 },
  { lng: -114.156752659866, lat: 51.077899433686 },
  { lng: -114.189810717426, lat: 51.057996933019 },
  { lng: -113.979753060394, lat: 50.874220978574 },
  { lng: -114.097884546102, lat: 50.979365564304 },
  { lng: -114.188307131572, lat: 51.136798559161 },
  { lng: -114.079760853235, lat: 51.046220919885 },
  { lng: -113.952538017583, lat: 51.128493210345 },
  { lng: -114.157916443165, lat: 50.985980667297 },
  { lng: -114.048987524874, lat: 51.059341486169 },
  { lng: -114.075305223009, lat: 51.084335925887 },
  { lng: -114.030168581584, lat: 51.051853892787 },
  { lng: -114.06298712389, lat: 51.030229623125 },
  { lng: -114.081521479382, lat: 51.184203387278 },
  { lng: -114.024707333634, lat: 50.950154038468 },
  { lng: -114.212106444857, lat: 51.063018937073 },
  { lng: -114.070187474812, lat: 51.040913830041 },
  { lng: -114.071265242419, lat: 51.160585362527 },
  { lng: -114.08583925956, lat: 50.964051230445 },
  { lng: -114.02984411472, lat: 50.976509365737 },
  { lng: -114.206886517139, lat: 51.009703704843 },
  { lng: -114.005692423779, lat: 51.041387532647 },
  { lng: -114.082362262865, lat: 51.16736075217 },
  { lng: -114.084215636645, lat: 51.060291621722 },
  { lng: -113.966193817057, lat: 51.159880978137 },
  { lng: -114.095846456957, lat: 50.917439896 },
  { lng: -114.140271308256, lat: 50.967697603312 },
  { lng: -114.000571278948, lat: 50.906712413886 },
  { lng: -114.010330916382, lat: 51.148126028439 },
  { lng: -114.243359302136, lat: 51.09599832921 },
  { lng: -114.238924756268, lat: 51.125939887441 },
  { lng: -114.150886809946, lat: 51.160001758547 },
  { lng: -113.95311046007, lat: 50.925720677286 },
  { lng: -114.06505235797, lat: 51.11125471755 },
  { lng: -114.205877622357, lat: 51.05537212315 },
  { lng: -113.932303383627, lat: 51.16238426466 },
  { lng: -114.134028073743, lat: 51.150140365224 },
  { lng: -114.095512873846, lat: 50.998090389361 },
  { lng: -114.080722287687, lat: 51.158272173201 },
  { lng: -113.986987659816, lat: 50.926366332437 },
  { lng: -114.135988106063, lat: 51.068104071949 },
  { lng: -114.079264138547, lat: 51.086418580184 },
  { lng: -114.220312964646, lat: 51.039408082972 },
  { lng: -113.960996472143, lat: 51.041748097365 },
  { lng: -113.944315253896, lat: 51.04575964224 },
  { lng: -114.103439190539, lat: 51.072530019039 },
  { lng: -114.088554542544, lat: 50.995643095387 },
  { lng: -114.098653175895, lat: 51.092706826156 },
  { lng: -114.048218895484, lat: 51.160584602422 },
  { lng: -113.996284621176, lat: 51.028640487454 },
  { lng: -114.11776070256, lat: 50.977820164663 },
  { lng: -114.25161856461, lat: 51.150689407547 },
  { lng: -113.94489763216, lat: 51.114728438817 },
  { lng: -114.074633193025, lat: 51.072689293739 },
  { lng: -114.065381610886, lat: 51.026490126881 },
  { lng: -114.223807396613, lat: 51.147477549051 },
  { lng: -114.082359095578, lat: 51.023449490048 },
  { lng: -114.036307768765, lat: 51.063658173849 },
  { lng: -114.190605048979, lat: 51.100324610898 },
  { lng: -113.995744374846, lat: 51.026538024071 },
  { lng: -114.082141467304, lat: 51.023368285822 },
  { lng: -114.109507019999, lat: 51.016391681894 },
  { lng: -114.046672034813, lat: 51.037286437722 },
  { lng: -113.934686557492, lat: 51.091217977778 },
  { lng: -114.068148201313, lat: 51.046304232662 },
  { lng: -113.964506740858, lat: 51.115504006416 },
  { lng: -114.171717279454, lat: 51.115188638007 },
  { lng: -114.031538069971, lat: 50.913303536765 },
  { lng: -113.934697523252, lat: 51.087806220844 },
  { lng: -114.117726627014, lat: 50.97672129249 },
  { lng: -114.129731456348, lat: 51.035466255184 },
  { lng: -114.134222420468, lat: 51.049525241694 },
  { lng: -114.088944835546, lat: 51.057908482517 },
  { lng: -114.064865518953, lat: 50.98724347461 },
  { lng: -114.221611940869, lat: 51.137868798338 },
  { lng: -113.988904021168, lat: 50.930757804217 },
  { lng: -114.022909034821, lat: 50.994807189821 },
  { lng: -114.123956413521, lat: 51.176035487065 },
  { lng: -114.208315224618, lat: 51.061579495192 },
  { lng: -114.157704718827, lat: 51.044334468676 },
  { lng: -114.044378064194, lat: 51.041007487995 },
  { lng: -114.047425687236, lat: 51.036768873355 },
  { lng: -114.09718780102, lat: 50.907166122364 },
  { lng: -114.003809489664, lat: 51.040819087326 },
  { lng: -114.238915603516, lat: 51.125923284324 },
  { lng: -113.990058059409, lat: 50.885952792554 },
  { lng: -114.103853782633, lat: 50.923842660749 },
  { lng: -114.097132311932, lat: 51.026180916979 },
  { lng: -114.206542830982, lat: 51.111642257072 },
  { lng: -113.994336653933, lat: 51.026699532811 },
  { lng: -114.154850974332, lat: 51.052074018376 },
  { lng: -114.112187506828, lat: 51.00666173461 },
  { lng: -113.987472574286, lat: 50.928627244681 },
  { lng: -114.2737539191, lat: 51.09448715111 },
  { lng: -113.986995440115, lat: 50.926388362195 },
  { lng: -114.067208307403, lat: 51.018849761584 },
  { lng: -114.090320382507, lat: 50.88155882402 },
  { lng: -114.252178730812, lat: 51.152867827053 },
  { lng: -114.214579100188, lat: 51.114393500172 },
  { lng: -114.03021943717, lat: 50.977523607961 },
  { lng: -114.157691271051, lat: 51.105731076084 },
  { lng: -114.237568716861, lat: 51.138321476337 },
  { lng: -114.122751872555, lat: 50.992471440573 },
  { lng: -113.952244413522, lat: 51.128233982561 },
  { lng: -114.1789166542, lat: 51.088739573383 },
  { lng: -114.116330077113, lat: 51.019192441851 },
  { lng: -114.202040193957, lat: 51.060663851863 },
  { lng: -113.978394455514, lat: 50.866505808355 },
  { lng: -114.06844500374, lat: 51.054892161369 },
  { lng: -114.077209534319, lat: 51.055529397178 },
  { lng: -113.928584914852, lat: 51.072889109498 },
  { lng: -114.081470600398, lat: 51.023852800498 },
  { lng: -114.140531653777, lat: 50.992308760298 },
  { lng: -113.98816157619, lat: 50.876742779566 },
  { lng: -113.942689357036, lat: 51.107196706439 },
  { lng: -114.153092832488, lat: 51.06473801588 },
  { lng: -114.21495863603, lat: 51.132122845378 },
  { lng: -114.10950947288, lat: 51.016418357668 },
  { lng: -113.92333549229, lat: 51.062422574075 },
  { lng: -114.082160660974, lat: 51.076095014706 },
  { lng: -114.15244157894, lat: 51.115457036419 },
  { lng: -114.044529200626, lat: 51.044550900614 },
  { lng: -113.980291062806, lat: 51.089336221039 },
  { lng: -114.196683101205, lat: 51.065940044681 },
  { lng: -114.093217986461, lat: 51.014129722946 },
  { lng: -114.019175263472, lat: 51.064797328141 },
  { lng: -114.064807724742, lat: 51.027105558423 },
  { lng: -113.923265772983, lat: 51.051347034693 },
  { lng: -114.226320480804, lat: 51.017788352526 },
  { lng: -114.137916272695, lat: 51.049068788582 },
  { lng: -114.097410665069, lat: 50.911806091361 },
  { lng: -113.950611219146, lat: 50.915440236743 },
  { lng: -113.964581482129, lat: 50.896005282648 },
  { lng: -114.095975306445, lat: 50.995859539782 },
  { lng: -114.028668344456, lat: 50.975159877093 },
  { lng: -114.030002324331, lat: 51.050990915884 },
  { lng: -114.213228500376, lat: 51.017379100201 },
  { lng: -113.928705998008, lat: 51.07183986343 },
  { lng: -114.094959068311, lat: 51.070777223371 },
  { lng: -114.136543049043, lat: 51.098954904576 },
  { lng: -113.984217429683, lat: 50.879194550604 },
  { lng: -114.008830713937, lat: 51.025740349967 },
  { lng: -114.095732677391, lat: 50.996751967647 },
  { lng: -113.922682840399, lat: 51.104525975843 },
  { lng: -113.986853274159, lat: 50.922507476354 },
  { lng: -114.085351097643, lat: 51.166162387032 },
  { lng: -114.031014692082, lat: 50.915581018964 },
  { lng: -114.077519251918, lat: 51.053939666881 },
  { lng: -114.142010056277, lat: 51.012092286502 },
  { lng: -114.226309440197, lat: 51.017817485543 },
  { lng: -114.155390195673, lat: 51.013275650628 },
  { lng: -114.015372112698, lat: 50.955964919868 },
  { lng: -113.996096594647, lat: 51.035476546349 },
  { lng: -114.269320128092, lat: 51.093217145242 },
  { lng: -113.923150547862, lat: 51.110170858028 }
]